const GREEN = "bg-green";
const ORANGE = "bg-orange";
const RED = "bg-status-error";

export const EN_ATTENTE = { label: "En attente de validation", color: ORANGE };
export const CONFORME = { label: "Conforme", color: GREEN };
export const NON_CONFORME = { label: "Non conforme", color: RED };

export const statutsDocuments = [EN_ATTENTE, CONFORME, NON_CONFORME];
